<template>
  <div class="publicMain">
    <el-row class="leftClass">
      <el-button
        size="mini"
        type="primary"
        style="margin-bottom: 10px"
        @click="openDialog('add')"
        >{{ $t("common.addedBtn") }}</el-button
      >
      <el-button
        size="mini"
        type="primary"
        style="margin-bottom: 10px"
        @click="xlhDialogVisible = true"
        >{{ $t("xtcs.xlhsz") }}</el-button
      >
    </el-row>
    <el-row>
      <el-table
        border
        :data="
          tableData.filter(
            (data) =>
              !search ||
              data.csid.toLowerCase().includes(search.toLowerCase()) ||
              data.csname.toLowerCase().includes(search.toLowerCase())
          )
        "
        style="width: 100%; font-size: 12px"
        :cellStyle="$store.state.cellStyle"
        :headerCellStyle="$store.state.headerCellStyle"
        :row-style="rowStyle"
      >
        <el-table-column
          :label="$t('xtcs.columnXh')"
          type="index"
          width="60px"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('xtcs.columnCsid')"
          prop="csid"
        ></el-table-column>
        <el-table-column
          :label="$t('xtcs.columnCsmc')"
          prop="csname"
        ></el-table-column>
        <el-table-column
          :label="$t('xtcs.columnCsz')"
          prop="csvalue"
          :show-overflow-tooltip="true"
        >
          <template #header>
            <p>
              <span class="mr-5">{{ $t("xtcs.columnCsz") }}</span>
              <el-input
                v-model="search"
                size="mini"
                :placeholder="$t('xmsq.searchPlaceholder')"
                style="width: 50%;"
              />
            </p>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('xtcs.columnCz')"
          align="center"
          width="120px"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog('edit', scope.row)">{{
              $t("common.editBtn")
            }}</el-button>
            <el-button type="text" @click="openDialog('del', scope.row)">{{
              $t("common.deleteBtn")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="handleClose"
    >
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size:16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-card>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          :validate-on-rule-change="false"
          size="small"
        >
          <el-form-item
            :label="$t('xtcs.columnCsid')"
            prop="csid"
            class="formClass"
          >
            <el-input
              :disabled="disabledFlg"
              v-model="ruleForm.csid"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('xtcs.columnCsmc')" prop="csname">
            <el-input v-model="ruleForm.csname"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xtcs.columnCsz')" prop="csvalue">
            <el-input v-model="ruleForm.csvalue">
              <el-color-picker
                v-if="ruleForm.colorVal.charAt(0) == '#'"
                v-model="ruleForm.colorVal"
                slot="prepend"
                @change="ruleForm.csvalue = ruleForm.colorVal"
              ></el-color-picker>
            </el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">{{
          $t("common.cancelBtn")
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitForm('ruleForm')"
          >{{ $t("xtcs.saveBtn") }}</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="xlhDialogVisible"
      width="680px"
      :show-close="false"
      custom-class="xlhdia"
    >
      <xlhsz></xlhsz>
    </el-dialog>
  </div>
</template>

<script>
import xlhsz from "@/layout/xlhsz.vue";
import * as yhxx from "@/api/yhxx";
import * as xtsz from "@/api/xtsz";
export default {
  name: "xtcs",
  components: {
    xlhsz,
  },
  computed: {
    rules() {
      // 模态框数据校验规则
      return {
        csid: [
          {
            required: true,
            message: this.$t("xtcs.ruleCsid"),
            trigger: "blur",
          },
        ],
        csname: [
          {
            required: true,
            message: this.$t("xtcs.ruleCsname"),
            trigger: "blur",
          },
        ],
        csvalue: [
          {
            required: true,
            message: this.$t("xtcs.ruleCsvalue"),
            trigger: "blur",
          },
        ],
      };
    },
    tabHeight() {
      return this.$store.state.screenHeight - 209;
    },
  },
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      xlhDialogVisible: false,
      dialogTitle: "", // 模态框标题
      ruleForm: {
        csid: "",
        csname: "",
        csvalue: "",
        iscolor: "0",
        colorVal: "",
      },
      dialogTitleIcon: "", // 模态框标题图标
      saveFlg: "", // 保存操作区分
      disabledFlg: false, // 输入框是否可编辑
      search: "",
      xlh: "",
    };
  },
  methods: {
    // 项目授权过滤
    rowStyle(val) {
      let row = val.row;
      if (this.search == "") {
        return;
      } else {
        if (
          row.csid.toLowerCase().includes(this.search.toLowerCase()) ||
          row.csname.toLowerCase().includes(this.search.toLowerCase())
        ) {
          return;
        } else {
          return {
            display: "none",
          };
        }
      }
    },
    /** 查询参数信息 */
    selectCs() {
      let _this = this;
      _this.tableData = [];
      yhxx.selectAllCs().then((res) => {
        if (res.data.code == "200") {
          _this.tableData = res.data.data;
          let tmpObj = {};
          for (let tmp of _this.tableData) {
            tmpObj[tmp.csid] = tmp.csvalue;
          }
          _this.$store.dispatch("setSysCs", tmpObj);
          _this.$store.commit("setCellStyle", {
            "font-size": this.$store.state.sysCs.tableFontSize + "px",
          });
          _this.$store.commit("setHeaderCellStyle", {
            background: this.$store.state.sysCs.tableHeaderBgColor,
            color: this.$store.state.sysCs.tableHeaderColor,
            "font-size": this.$store.state.sysCs.tableHeaderFontSize + "px",
          });
        }
      });
    },
    /** 打开模态框 */
    openDialog(flg, row) {
      if (flg == "add") {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t("xtcs.addDiaTitle");
          this.dialogTitleIcon = "el-icon-document-add";
          this.disabledFlg = false;
        });
      } else if (flg == "edit") {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t("xtcs.editDiaTitle");
          this.dialogTitleIcon = "el-icon-edit-outline";
          this.ruleForm.csid = row.csid;
          this.ruleForm.csname = row.csname;
          this.ruleForm.csvalue = row.csvalue;
          row.csvalue.charAt(0) == "#"
            ? (this.ruleForm.colorVal = row.csvalue)
            : (this.ruleForm.colorVal = "");
          this.disabledFlg = true;
        });
      } else if (flg == "del") {
        this.delXtcs(row.csid);
      }
      this.saveFlg = flg;
    },
    handleClose(done) {
      this.$refs["ruleForm"].resetFields();
      this.ruleForm.colorVal = this.ruleForm.csvalue;
    },
    /** 保存模态框数据 */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.saveFlg === "add") {
            this.addXtcs();
          } else if (this.saveFlg === "edit") {
            this.editXtcs();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 新增系统参数 */
    addXtcs() {
      let _this = this;
      xtsz
        .addXtcs(_this.ruleForm)
        .then((res) => {
          _this.dialogFormVisible = false;
          if (res.data.code == "200") {
            _this.selectCs();
            _this.$message.success(_this.$t("xtcs.addSuccess"));
          }
        })
        .catch((error) => {
          _this.dialogFormVisible = false;
        });
    },
    /** 编辑系统参数 */
    editXtcs() {
      let _this = this;
      xtsz
        .updateXtcs(_this.ruleForm)
        .then((res) => {
          _this.dialogFormVisible = false;
          if (res.data.code == "200") {
            _this.$message.success(_this.$t("xtcs.editSuccess"));
            this.selectCs();
          }
        })
        .catch((error) => {
          _this.dialogFormVisible = false;
        });
    },
    /** 删除系统参数 */
    delXtcs(csid) {
      let _this = this;
      _this
        .$confirm(
          _this.$t("xtcs.deleteContent"),
          _this.$t("xtcs.deleteTitle"),
          {
            distinguishCancelAndClose: true,
            confirmButtonText: _this.$t("common.confirmBtn"),
            cancelButtonText: _this.$t("common.cancelBtn"),
          }
        )
        .then((res1) => {
          xtsz.delXtcs(_this.$qs.stringify({ csid: csid })).then((res) => {
            if ((res.data.code = "200")) {
              _this.selectCs();
              _this.$message.success(_this.$t("xtcs.delSuccess"));
            }
          });
        })
        .catch((action) => {});
    },
  },
  mounted() {
    this.selectCs();
  },
};
</script>
<style lang="scss" scoped>
.xlhrow {
  background-color: #f8fbff;
  width: 680px;
  height: 380px;
  margin: auto;
  padding: 32px 46px;
  background-image: url(/img/xlhbg.png);
  background-position: right top;
  background-repeat: no-repeat;
}
.xlhbg {
  width: 100%;
  height: 100%;
  // padding: 32px 46px;
}
.szht {
  width: 110px;
  height: 26px;
}
.xtmc {
  // width: 350px;
  height: 31px;
  font-size: 32px;
  font-family: MiSans;
  font-weight: 800;
  color: #333333;
  line-height: 24px;
  margin-top: 30px;
}
.bbh {
  width: 66px;
  height: 20px;
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}
.bbts {
  width: 83px;
  height: 13px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #e37f1f;
  line-height: 24px;
  margin-left: 11px;
}
.yxq {
  width: 280px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-top: 60px;
}
.yxqms {
  width: 204px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  line-height: 24px;
  margin-left: 19px;
}
.xlh {
  width: 500px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-top: 28px;
}
.xlhinput {
  width: 300px;
  height: 32px;
  margin-left: 19px;
}
.xlhbnt {
  width: 100px;
  height: 32px;
  background: #0d6ce4;
  border-radius: 3px;
  margin-left: 10px;
}
.bqsy {
  width: 237px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-top: 60px;
}
.formClass {
  margin-bottom: 16px;
}
::v-deep .el-input-group__prepend {
  border: none;
  padding: 0;
}
::v-deep .xlhdia {
  padding: 0px !important;
  .el-dialog__header {
    padding: 0px !important;
  }
  .el-dialog__body {
    padding: 0px !important;
  }
}
</style>
